import { render, staticRenderFns } from "./AddUpdateAutoAssignments.vue?vue&type=template&id=23c4702a&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./AddUpdateAutoAssignments.vue?vue&type=script&lang=js"
export * from "./AddUpdateAutoAssignments.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateAutoAssignments.vue?vue&type=style&index=0&id=23c4702a&prod&scoped=true&lang=css"
import style1 from "./AddUpdateAutoAssignments.vue?vue&type=style&index=1&id=23c4702a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c4702a",
  null
  
)

export default component.exports